<script setup lang="ts">
// ============================================================================
// Imports
// ============================================================================
import type { VerificationResponse } from '@/interfaces/verification'

// ============================================================================
// Props
// ============================================================================
interface Props {
  verification?: VerificationResponse | null
}

const props = defineProps<Props>()
</script>

<template>
  <!-- ===================================================================== -->
  <!-- QR Mark Branding Footer -->
  <!-- ===================================================================== -->
  <!-- Displays QR Mark branding when show_branding is enabled -->
  <div
    v-if="verification && verification.show_branding"
    class="text-center mt-8 pt-4 border-t border-gray-200"
  >
    <p class="text-gray-500 text-xs font-medium mb-2">Powered By</p>
    <a href="https://qrmark.com" target="_blank" rel="noreferrer" class="inline-block">
      <img
        width="100"
        height="60"
        src="@/assets/img/qrmark-logo-full-text.svg"
        alt="QR Mark"
        class="mx-auto"
      />
    </a>
    <p class="text-xs text-gray-600 mt-2 max-w-md mx-auto">
      QR Mark provides an end-to-end document authentication solution. Secure your documents with
      <a class="text-secondary-500 hover:underline" target="_blank" href="https://qrmark.com">
        QR Mark
      </a>.
    </p>
  </div>
</template>

